import React from 'react';
import type { Modifier as _Modifier, ModifierGroup } from 'root/apiTypes';
import { classes } from './ModifierGroups.st.css';
import { dataHooks } from 'root/dataHooks';
import { Modifier } from 'root/components/Menus/Modifier/Modifier';
import { useModifierGroupsLogic } from './ModifierGroups.logic';
import { Text } from 'wix-ui-tpa/cssVars';

export const ModifierGroups = ({ modifierGroups }: { modifierGroups: ModifierGroup[] }) => {
  const { modifierGroupTitleHtmlTag } = useModifierGroupsLogic();
  return (
    <div className={classes.modifierGroups} data-hook={dataHooks.item.modifierGroups} role="list">
      {modifierGroups.map((modifierGroup: ModifierGroup) => (
        <div key={modifierGroup?.id} className={classes.modifierGroup}>
          <Text
            className={classes.modifierGroupName}
            data-hook={dataHooks.modifierGroup.name}
            tagName={modifierGroupTitleHtmlTag}
          >
            {modifierGroup?.name}
          </Text>
          <div className={classes.modifiers}>
            {modifierGroup.modifiers?.map((modifier: _Modifier) => (
              <Modifier key={modifier.id} modifier={modifier} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
